import { render } from "./IconMenuManegmentComponent.vue?vue&type=template&id=11c37b3f&scoped=true&ts=true"
import script from "./IconMenuManegmentComponent.vue?vue&type=script&lang=ts"
export * from "./IconMenuManegmentComponent.vue?vue&type=script&lang=ts"

import "./IconMenuManegmentComponent.vue?vue&type=style&index=0&id=11c37b3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11c37b3f"]])

export default __exports__